/**
 * 竞价汇总信息
 */
import React from 'react';

import { Row, Col, Tooltip, DatePicker, Statistic, Select, Button } from 'antd';

import PageLayout from '../../ui/PageLayout';

import { fixedNumber } from '../../../util/util';

import http from '../../../axios/http';


//引入消息提示相关组件
import messager from '../../ui/messager';

//引入消息提示相关组件
import Loading from '../../ui/Loading';


class AuctionSummaryIndex extends React.Component {

    querySelectDict = {
        //渠道
        channel: [
            "全部",
            "建发汽车",
            "非建发汽车",
        ],
        //地区
        area: [
            "全部",
            "厦门市",
            "泉州市",
            "莆田市",
            "福州市",
            "沈阳市",
            "西安市",
            "南宁市",
            "昆明市",
            "汕头市",
        ],
        brand: [
            "全部",
            "宾利",
            "迈凯伦",
            "马丁",
            "保时捷",
            "捷豹路虎",
            "奥迪",
            "凯迪拉克",
            "生活馆",
            "林肯",
            "沃尔沃",
            "讴歌",
            "红旗",
            "三菱",
            "大众",
            "威马",
            "大通",
            "阿尔法罗密欧",
        ]
    };

    //统计信息的数据
    statisticFields = [{
        "field": "sessionNum",
        "text": "竞价场数",
    }, {
        "field": "lotsNum",
        "text": "竞价车辆数",
    }, {
        "field": "dealNum",
        "text": "成交台数",
    }, {
        "field": "dealRate",
        "text": "成交率",
    }, {
        "field": "maxBidTimes",
        "text": "最高出价次数",
    }, {
        "field": "maxPremiumAmount",
        "text": "最高溢价金额",
    }, {
        "field": "maxPremiumRate",
        "text": "最高溢价率",
    }, {
        "field": "totalPremiumAmount",
        "text": "整体溢价金额",
    }, {
        "field": "totalPremiumRate",
        "text": "整体溢价率",
    }];

    columns = [{
        title: '车辆名称',
        dataIndex: 'name',
        width: '20%',
    }, {
        title: '车辆来源',
        dataIndex: 'clientSource',
        width: '10%',
    }, {
        title: '竞价日期',
        dataIndex: 'startDate',
        width: '15%',
    }, {
        title: '竞价结果',
        dataIndex: 'status',
        width: '10%',
        format: { 0: '无人出价', 1: '成功', 2: '低于保留价', 3: '竞价成功，但没有成交' }
    }, {
        title: '起拍价',
        dataIndex: 'startPrice',
        width: '10%',
    }, {
        title: '成交价',
        dataIndex: 'finalPrice',
        width: '10%',
    }, {
        title: '溢价金额',
        dataIndex: 'premiumAmount',
        width: '10%',
    }, {
        title: '溢价率',
        dataIndex: 'premiumRate',
        width: '10%',
        render: (text, record, index) => {
            let val = text != null && text !== "" ? fixedNumber(text * 100, 2) + "%" : "";
            return (<Tooltip title={val} >{val}</Tooltip>)
        }
    }, {
        title: '出价次数',
        dataIndex: 'bidTimes',
        width: '10%',
    }];

    state = {
        loadData: '',
        queryData: {},
        loadingVisible: false,

        countData: {},
    };

    componentDidMount() {
        this.loadAuctionCount();
    }

    loadAuctionCount = (queryData) => {
        http.get({
            url: '/auctionSummary/findAuctionCount',
            data: queryData,
            success: (res) => {
                this.setState({ countData: res == null ? {} : res });
            }
        });
    }


    rangePickerChange = (dates, dateStrings) => {
        let queryData = this.state.queryData;
        queryData.startDate = dateStrings[0];
        queryData.endDate = dateStrings[1];
        this.setState({ queryData: queryData });
        // this.state.loadData(queryData);
        // this.loadAuctionCount(queryData);
        this.loadPageData(queryData);
    }

    selectChange = (field, data, e) => {
        let queryData = this.state.queryData;
        data = data === "全部" ? "" : data;
        queryData[field] = field === "area" ? data.replace("市", "") : data;
        this.setState({ queryData: queryData });
        // this.state.loadData(queryData);
        // this.loadAuctionCount(queryData);
        this.loadPageData(queryData);
    }

    loadPageData = (data) => {
        let queryData = { ...data };
        if (queryData.channel !== "建发汽车") {
            queryData.area = null;
            queryData.brand = null;
        }
        this.state.loadData(queryData);
        this.loadAuctionCount(queryData);
    }

    download = () => {
        let queryData = this.state.queryData;
        if (queryData.startDate == null || queryData.startDate === "" || queryData.endDate == null || queryData.endDate === "") {
            messager.notify("导出时需选择时间段！", null, "warning");
            return;
        }
        queryData.pageNumber = 1;
        queryData.pageSize = 5000;
        this.setState({ loadingVisible: true });
        let fileName = queryData.startDate + "~" + queryData.endDate + " 竞价汇总信息.xlsx";
        http.download({
            url: '/auctionSummary/download',
            data: queryData,
            fileName: fileName,
            success: (res) => {
                this.setState({ loadingVisible: false });
            },
            error: (res) => {
                this.setState({ loadingVisible: false });
            }
        });
    }



    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={24}>
                                <DatePicker.RangePicker onChange={this.rangePickerChange} />
                                <Select defaultValue="" onChange={this.selectChange.bind(this, "channel")} style={{ width: '150px', margin: "0 10px" }}>
                                    {this.querySelectDict.channel.map((item, index) =>
                                        <Select.Option value={item} key={index}>{item}</Select.Option>
                                    )}
                                </Select>
                                <Select defaultValue="全部" onChange={this.selectChange.bind(this, "area")} disabled={this.state.queryData["channel"] !== "建发汽车"} style={{ width: '150px' }}>
                                    {this.querySelectDict.area.map((item, index) =>
                                        <Select.Option value={item} key={index}>{item}</Select.Option>
                                    )}
                                </Select>
                                <Select defaultValue="全部" onChange={this.selectChange.bind(this, "brand")} disabled={this.state.queryData["channel"] !== "建发汽车"} style={{ width: '150px', marginLeft: "10px" }}>
                                    {this.querySelectDict.brand.map((item, index) =>
                                        <Select.Option value={item} key={index}>{item}</Select.Option>
                                    )}
                                </Select>
                                <Button type="primary" onClick={this.download} style={{ float: "right" }}>导出</Button>
                            </Col>
                            <Col span={24}>
                                <Row style={{ marginTop: '10px', paddingTop: '10px', borderTop: '1px solid #e8e8e8' }}>
                                    {this.statisticFields.map((item, index) => {
                                        let val = this.state.countData[item.field];
                                        val = val == null ? 0 : val;
                                        if (item.field === "dealRate") {
                                            val = this.state.countData["lotsNum"] === 0 ? 0 : this.state.countData["dealNum"] / this.state.countData["lotsNum"];
                                        }
                                        let span = index > 2 ? 3 : 2;
                                        return <Col span={span} key={index} style={{ textAlign: 'center' }}>
                                            {
                                                item.field === "totalPremiumRate" || item.field === "maxPremiumRate" || item.field === "dealRate" ?
                                                    <Statistic title={item.text} value={fixedNumber(val * 100, 2)} suffix="%" precision={2} />
                                                    : <Statistic title={item.text} value={val} />
                                            }
                                        </Col>;
                                    })}
                                </Row>
                            </Col>
                        </Row>
                    )}
                    rowKey="id"
                    url="/auctionSummary/findResultPage"
                    columns={this.columns}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                />
                <Loading visible={this.state.loadingVisible} message="处理中，请稍候..." />
            </div>
        )
    }

}

export default AuctionSummaryIndex;